import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function createBookPage(bookData) {
  try {
    
    const encodedData = btoa(JSON.stringify(bookData));

    const fd = new FormData();
    fd.append("booking_page_data", encodedData);

    const response = await axios.post(`${apiBaseUrl}bookpage/create_book`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createBookPage error:", error);
    return { status: false, type: "danger", success: "Failed to save booking page" };
  }
}

// 🔹 Get Booking Pages List
export async function getBookPages(
  booking_page_cre_by,
  page_no = "0",
  booking_page_status = "",
  booking_page_website = "",
  search_key = ""
) {
  try {
    const fd = new FormData();
    fd.append("booking_page_cre_by", booking_page_cre_by);
    fd.append("page_no", page_no);
    fd.append("booking_page_status", booking_page_status);
    fd.append("booking_page_website", booking_page_website);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}bookpage/get_books`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getBookPages error:", error);
    return { status: false, type: "danger", success: "Failed to load booking pages" };
  }
}

// 🔹 Get Booking Page Report
export async function getBookPageReport(booking_page_cre_by) {
  try {
    const fd = new FormData();
    fd.append("booking_page_cre_by", booking_page_cre_by);

    const response = await axios.post(`${apiBaseUrl}bookpage/get_book_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getBookPageReport error:", error);
    return { status: false, type: "danger", success: "Failed to load booking page report" };
  }
}

// 🔹 Delete Booking Page
export async function deleteBookPage(booking_page_id) {
  try {
    const fd = new FormData();
    fd.append("booking_page_id", booking_page_id);

    const response = await axios.post(`${apiBaseUrl}bookpage/delete_book`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteBookPage error:", error);
    return { status: false, type: "danger", success: "Failed to delete booking page" };
  }
}

// 🔹 Update Booking Page Status
export async function updateBookPageStatus(booking_page_id, booking_page_status) {
  try {
    const fd = new FormData();
    fd.append("booking_page_id", booking_page_id);
    fd.append("booking_page_status", booking_page_status);

    const response = await axios.post(`${apiBaseUrl}bookpage/update_book_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateBookPageStatus error:", error);
    return { status: false, type: "danger", success: "Failed to update booking page status" };
  }
}
export async function checkBookingPageUrl(url, booking_page_id = "") {
  try {
    const fd = new FormData();
    fd.append("booking_page_url", url);
    fd.append("booking_page_id", booking_page_id);

      const response = await axios.post(`${apiBaseUrl}bookpage/check_booking_page_url`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });


    return response.data;
  } catch (err) {
    console.error("checkBookingPageUrl error:", err);
    return {
      status: false,
      available: false,
      success: "Failed to check URL"
    };
  }
}

